/* Issue #17 — Mirror current PDP variant price into the ATC button label. */
(function () {
  'use strict';

  function findPriceSource() {
    // .pdp-price wraps the Shopify price block that gets updated on variant change.
    // It contains either .price__regular .price-item--regular or (on sale) .price__sale .price-item--last.
    var container = document.querySelector('.pdp-price');
    if (!container) return null;
    return container;
  }

  function currentPriceText(container) {
    // Prefer the sale price when visible, otherwise regular price.
    var onSale = container.querySelector('.price--on-sale');
    var node;
    if (onSale) {
      node = container.querySelector('.price__sale .price-item--last, .price__sale .price-item--sale');
    } else {
      node = container.querySelector('.price__regular .price-item--regular');
    }
    if (!node) node = container.querySelector('.price-item');
    if (!node) return null;
    return (node.textContent || '').trim();
  }

  function updateButtons(priceText) {
    if (!priceText) return;
    document.querySelectorAll('.atc-btn [data-atc-price]').forEach(function (el) {
      if (el.textContent.trim() !== priceText) {
        el.textContent = priceText;
      }
    });
  }

  function wire() {
    var container = findPriceSource();
    if (!container) return false;
    var run = function () { updateButtons(currentPriceText(container)); };
    run();
    var mo = new MutationObserver(run);
    mo.observe(container, { childList: true, subtree: true, characterData: true });
    return true;
  }

  function init() {
    if (wire()) return;
    var outer = new MutationObserver(function () {
      if (wire()) outer.disconnect();
    });
    outer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { outer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
